import React from 'react';
import './App.css';
import { Login } from './login/Login';
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { Main } from './main/Main';
import { Public } from './public/Public';
import Authen from './core/Authen';
import '../node_modules/bootstrap/dist/js/bootstrap';

function App() {
  function PrivateRoute({ children, ...rest }) {
    return (
      <Route {...rest} render={() => {
        if (Authen.checkAccess()) {
          return children;
        }
        else {
          return (
            <Redirect to="/login"></Redirect>
          )
        }
      }}>
      </Route>
    )
  }

  return (
    <Router>
      <Switch>
        <Route path="/" exact>
          <Redirect to="/public"></Redirect>
        </Route>
        <Route path="/login">
          <Login></Login>
        </Route>
        <Route path="/public">
          <Public></Public>
        </Route>
        <Route path="/main">
          <Main></Main>
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
